import { render } from "./privacyPolicy.vue?vue&type=template&id=139e6001&ts=true"
import script from "./privacyPolicy.vue?vue&type=script&lang=ts"
export * from "./privacyPolicy.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__